export const createQueryParamsAsString = (queryParams) => {
  return Object.keys(queryParams)
    .filter((key) => !!queryParams[key])
    .map((key) => `${key}=${queryParams[key]}`)
    .join('&');
};
